import api from './api';
import axios from 'axios';
import { constURL } from './enum.services';
import { regUserI } from '../interfaces/user';
import { ErrorResponse } from './types.services';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const registrationUser = createAsyncThunk(
  'user/registration',
  async (regUser: regUserI, { rejectWithValue }) => {
    try {
      const response = await api.post(constURL.REGISTRATION, regUser);
      console.log(`ответ на регистрацию: ${response.data.message}`);
      // console.log(`ответ на регистрацию2: ${response.data}`);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        // console.log(rejectWithValue(error.response.status));
        console.log(rejectWithValue(error.response));
        return rejectWithValue(error.response.status);
      }
      throw error;
    }
  }
);
